import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SignupPage } from './pages/SignupPage';
import { ContactPage } from './pages/ContactPage';
import { CityPage } from './pages/CityPage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-neutral-900 selection:bg-red-100 selection:text-red-900" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/signup" element={<SignupPage data-id="element-7" />} data-id="element-6" />
          <Route path="/contact" element={<ContactPage data-id="element-9" />} data-id="element-8" />
          <Route path="/taekwondo-near-grapevine-texas" element={<CityPage data-id="element-11" />} data-id="element-10" />
        </Routes>
        <Footer data-id="element-12" />
      </div>
    </BrowserRouter>;
}